/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import "./icon-DGn-d_zv.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s, state as c } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/balance/balance.css.js
var l = r("ptc-ui-balance,:host{--balance-color-negative:var(--red);--balance-color-positive:var(--green);vertical-align:middle;display:inline-block}ptc-ui-balance[sign=\"-1\"],:host([sign=\"-1\"]){color:var(--balance-color-negative)}ptc-ui-balance[sign=\"1\"],:host([sign=\"1\"]){color:var(--balance-color-positive)}ptc-ui-balance[inverted],:host([inverted]){--balance-color-negative:var(--green);--balance-color-positive:var(--red)}"), u = class extends e(i) {
	constructor(...e) {
		super(...e), this.styles = l, this.value = 0, this.parser = (e) => Intl.NumberFormat(void 0, {
			style: "decimal",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
			signDisplay: "never"
		}).format(e), this.inverted = !1, this.iconStyle = "plus-minus", this.sign = 0;
	}
	_getSignIcon(e) {
		if (e !== 0) return this.iconStyle === "up-down" ? e === -1 ? "icon.object.trend-down" : "icon.object.trend-up" : e === -1 ? "icon.object.sign-minus" : "icon.object.sign-plus";
	}
	willUpdate(e) {
		e.has("parser") && (this._formattedValue = this.parser(Math.abs(this.value))), e.has("value") && (this._formattedValue = this.parser(Math.abs(this.value)), this.sign = Math.sign(this.value));
	}
	render() {
		let e = this._getSignIcon(this.sign);
		if (this.value !== null && this.value !== void 0) return a`
            <div class="ptc-balance inline-flex items-center gap-0.5">
                ${e && a`<ptc-ui-icon part="sign" name=${e} class="font-size-0.75em"></ptc-ui-icon>`}
                ${this._formattedValue}
                <slot></slot>
            </div>
        `;
	}
};
n([s({ type: Number }), t("design:type", Object)], u.prototype, "value", void 0), n([s({ attribute: !1 }), t("design:type", Function)], u.prototype, "parser", void 0), n([s({
	type: Boolean,
	reflect: !0
}), t("design:type", Boolean)], u.prototype, "inverted", void 0), n([s({ type: String }), t("design:type", String)], u.prototype, "iconStyle", void 0), n([s({
	type: Number,
	reflect: !0
}), t("design:type", Object)], u.prototype, "sign", void 0), n([c(), t("design:type", String)], u.prototype, "_formattedValue", void 0), u = n([o("ptc-ui-balance")], u);
var d = u;
//#endregion
export { d as n, u as t };

//# sourceMappingURL=balance-B7IKMgqL.js.map